module.exports = __webpack_public_path__ + "img/russells-viper.12ce79de.jpg";